import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux'; // Import useSelector
import Login from './components/login/Login';
import  Logout  from './components/login/Logout';
import Profile from './components/login/Profile';
import Tenants from './components/superadmin/tenants/Tenants';
import Users from './components/admin/users/Users';
import PasswordHandler from './components/dmz/PasswordHandler';
import SmartBillImport from './components/smartbill/invoices/SmartBill-Import';
import SmartBillCustomerImport from './components/smartbill/customers/SmartBillCustomerImport';
import SmartBillCustomers from './components/smartbill/customers/SmartBillCustomers';
import ProductImportStock from './components/smartbill/stock/ProductImportStock';
import WarehouseManagement from './components/smartbill/warehouse/WarehouseManagement';
import ProductStock from './components/smartbill/stock/ProductStock';
import PropertyManagement from './components/admin/properties/PropertyManagement';
import Home from './components/public/Home';
import NotFound from './components/public/NotFound';
import RequestEdit from './components/smartbill/invoices/RequestEdit';
import InvoiceList from './components/smartbill/invoices/InvoiceList';

// Example components
const About = () => <div>About Page</div>;
const Contact = () => <div>Contact Page</div>;

const AllRoutes = () => {
    const currentUser = useSelector((state) => state.user.data);
    const userRoles = useSelector((state) => state.user.roles);
    const isSuperAdmin = !!currentUser && userRoles.includes('ROLE_SUPERADMIN');
    const isAdmin = (!!currentUser && userRoles.includes('ROLE_ADMIN')) || isSuperAdmin;
    const accessSmartBill =  isSuperAdmin || (!!currentUser && userRoles.includes('ROLE_SMARTBILL'));

    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            { !currentUser ? <Route path="/login" element={<Login />} /> : <Route path="/login" element={<Profile />} /> }
            { !!currentUser && <Route path="/logout" element={<Logout />} /> }
            { !!currentUser && <Route path="/profile" element={<Profile />} /> }
            { isSuperAdmin && <Route path="/admin/tenants" element={<Tenants />} /> }
            
            { isAdmin && <Route path="/admin/users" element={<Users />} /> }
            { isAdmin && <Route path="/admin/properties" element={<PropertyManagement />} /> }

            { accessSmartBill && <Route path="/smartbill/invoice" element={<SmartBillImport />} /> }
            { accessSmartBill && <Route path="/smartbill/customers" element={<SmartBillCustomers />} /> }
            { accessSmartBill && <Route path="/smartbill/customers/import" element={<SmartBillCustomerImport />} /> }
            
            { accessSmartBill && <Route path="/smartbill/stock" element={<ProductStock />} /> }
            { accessSmartBill && <Route path="/smartbill/stock/import" element={<ProductImportStock />} /> }
            { accessSmartBill && <Route path="/smartbill/warehouse" element={<WarehouseManagement />} /> }

            { accessSmartBill && <Route path="/smartbill/invoices" element={<InvoiceList />} />}
            { accessSmartBill && <Route path="/smartbill/invoice/import" element={<SmartBillImport />} />}
            { accessSmartBill && <Route path="/smartbill/invoice/edit/:id" element={<RequestEdit />} />}

            <Route path="/dmz/*" element={<PasswordHandler />} />

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default AllRoutes;
